import { loadRemote } from '@module-federation/runtime'
// Util function to mount and unmount the appopintment modal based on the type
import { useAppContext } from '../pmd/composition/useAppContext'
import config from '../config'
import store from '../store'
import { getJWT } from './jwt_helper'
import { getCalendarData } from './calendar_modal'


let calendarIntegrationApp: any = {}
let troubleshootCalendarApp: any = {}
let reconnectModal: any = {}
let serviceSettingsApp: any = {}
let calendarScheduleApp: any = {}
let removeDeletedCalendarsApp: any = {}

// Function to mount a modal component
async function mountCalendarSettingsApp(mountId: string, configuration: any) {
  const globallyMountedApps = ["ReconnectModal", "RemoveDeletedCalendars"] // If the app is globally mounted, we don't need to unmount other apps while mounting this app
  if (!globallyMountedApps.includes(mountId)) {
    if (calendarIntegrationApp?.unmount) calendarIntegrationApp?.unmount()
    if (troubleshootCalendarApp?.unmount) troubleshootCalendarApp?.unmount()
    if (serviceSettingsApp?.unmount) serviceSettingsApp?.unmount()
    if (calendarScheduleApp?.unmount) calendarScheduleApp?.unmount()
  }


  const { mountAppContext } = useAppContext()
  let Component
  switch (mountId) {
    case 'CalendarIntegration':
      Component = "CalendarIntegration"
      break
    case 'TroubleshootCalendar':
      Component = "TroubleshootCalendar"
      break
    case 'ReconnectModal':
      Component = "ReconnectModal"
      break
    case 'ServiceSettings':
      Component = "ServiceSettings"
      break
    case 'CalendarSchedule':
      Component = "CalendarSchedule"
      break
    case 'RemoveDeletedCalendars':
      Component = "RemoveDeletedCalendars"
      break
    default:
      Component = null
  }

  try {
    const [createApp, calendarComponent] = await Promise.all([
      loadRemote('calendarSettingsApp/vue3').then((m: any) => m.createApp),
      loadRemote('calendarSettingsApp/'+Component).then((m: any) => m.default),
    ])
    const calendarSettingsApp = createApp(calendarComponent, {
      ...configuration,
    })
    mountAppContext({ calendarSettingsApp })
    calendarSettingsApp.mount(`#${mountId}`)
    if (mountId === 'CalendarIntegration') {
      calendarIntegrationApp = calendarSettingsApp
    } else if (mountId === 'TroubleshootCalendar') {
      troubleshootCalendarApp = calendarSettingsApp
    } else if (mountId === 'ServiceSettings') {
      serviceSettingsApp = calendarSettingsApp
    } else if (mountId === 'CalendarSchedule') {
      calendarScheduleApp = calendarSettingsApp
    } else if (mountId === 'RemoveDeletedCalendars') {
      removeDeletedCalendarsApp = calendarSettingsApp
    } else if (mountId === 'ReconnectModal') {
      reconnectModal = calendarSettingsApp
    }
  }
  catch (e) {
    console.error(e)
  }
}

// Function to unmount a modal component
function unmountCalendarSettingsApp(mountId: string) {
  let appToUnmount

  switch (mountId) {
    case 'CalendarIntegration':
      appToUnmount = calendarIntegrationApp
      break
    case 'TroubleshootCalendar':
      appToUnmount = troubleshootCalendarApp
      break
      case 'ReconnectModal':
        appToUnmount = reconnectModal
        break
    case 'ServiceSettings':
      appToUnmount = serviceSettingsApp
      break
    case 'CalendarSchedule':
      appToUnmount = calendarScheduleApp
      break
    case 'RemoveDeletedCalendars':
      appToUnmount = removeDeletedCalendarsApp
      break
  }
  if (appToUnmount?.unmount) {
    try {
      const mountElement = document.getElementById(mountId)
      if (mountElement) {
        appToUnmount.unmount()
      }
    } catch (error) {} finally {
      window['calendarSettingsApp'] = null
    }
  }
}

export async function getCalendarSettingsData(currentLocationId: string) {
  const data = await getCalendarData(currentLocationId)
  const isServicesEnabled = store.getters['calendars/isServicesEnabled']
  const services = store.getters['calendars/getAllServices']
  const authToken = await getJWT(true)
  return {
    locale: data.locale,
    locationId: currentLocationId,
    userId: data?.userId,
    source: 'connections_tab',
    isFullWidth: true,
    loggedInUserInfo: data.loggedInUserInfo,
    authToken: authToken,
    isServicesEnabled: isServicesEnabled,
    services: services,
    customObjectLabels: data.customObjectLabels
  }
}

export { mountCalendarSettingsApp, unmountCalendarSettingsApp }
